import { LoadableAfterPaint } from '@confluence/loadable';

export const DetailsExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DetailsExtensionHandler" */ '../src/DetailsExtensionHandler.tsx'
			)
		).DetailsExtensionHandler,
});
